import { Grid } from "@mui/material";
import { useSuperAdminEventos } from "../../../context/SuperAdmin/EventsContext";
import { CustomTab, CustomTabs } from "./CustomItems";
import EventosSelectMenu from "./EventosSelectMenu";
import { Spinner } from "../../Loading/Spinner";
import EventosTable from "./EventosTable";
import { useAuthContext } from "../../../hooks/Auth";

const EventosSA = () => {
  const { tabValue, handleTabChange, isLoadingOpts } = useSuperAdminEventos();
  const { canAccess } = useAuthContext();
  const isSuperAdmin = canAccess("view:reports");
  return (
    <Grid
      container
      sx={{
        display: "flex",
        flexDirection: "column",
        width: 1,
        marginX: "auto",
        paddingX: 3,
        marginTop: 0,
        gap: 2,
      }}
    >
      {/* Tabs de tipo de eventos: organizaciones o paises */}
      {isSuperAdmin && (
        <Grid item>
          <CustomTabs
            value={tabValue}
            onChange={(_, newValue: 0 | 1) => handleTabChange(newValue)}
            variant="fullWidth"
          >
            <CustomTab label="Organización" />
            <CustomTab label="País" />
          </CustomTabs>
        </Grid>
      )}

      {/* Si las opciones del select están cargando no se muestra nada */}
      {isLoadingOpts ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Selects más específico: usuarios, organizacines o paises */}
          {isSuperAdmin && (
            <Grid item>
              <EventosSelectMenu />
            </Grid>
          )}

          {/* Tabla de Eventos */}
          <Grid item>
            <EventosTable />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default EventosSA;
